import { Command } from '@/plugins/cad/module/core/Command'
import type { CADViewManager } from '../manager/CADViewManager'
import type { IEntity } from '../model/entity'

/**
 * 绘制填充命令，支持在交互中逐步追加填充实体并整体撤销/重做。
 */
export class DrawHatchCommand extends Command {
  private entities: IEntity[] = []

  constructor(private viewManager: CADViewManager) {
    super()
  }

  /** 实际添加操作在 addEntity 中完成，这里为空实现 */
  execute(): void {
    // 实际的添加操作在 addEntity 方法中进行
  }

  /** 撤销：移除本次命令加入的全部填充实体 */
  undo(): void {
    this.viewManager.deleteEntities(this.entities)
  }

  /** 重做：重新加入本次命令的填充实体 */
  redo(): void {
    // 重新添加实体
    this.viewManager.addEntities(this.entities)
  }

  /** 分步撤销：移除最近一次加入的实体 */
  undoStep(): void {
    // 删除最后一个实体
    if (this.canUndoStep()) {
      const entity = this.entities.pop()!
      this.viewManager.deleteEntity(entity)
    }
  }

  /**
   * 是否支持分步撤销。
   *
   * @returns 存在已加入的填充实体时返回 true
   */
  canUndoStep(): boolean {
    return this.entities.length > 0
  }

  /**
   * 是否允许提交命令。
   *
   * @returns 至少加入过一个填充实体时返回 true
   */
  canCommit(): boolean {
    return this.entities.length > 0
  }

  /**
   * 追加一个填充实体并立即加入视图。
   *
   * @param entity - 新增的填充实体
   */
  addEntity(entity: IEntity) {
    this.entities.push(entity)
    this.viewManager.addEntity(entity)
  }
}
